import React from 'react';

import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';
import { Row, Col, Button, Checkbox, Select, DatePicker } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { descargarCSV } from '../../administracion/funciones/descargarCSV';
import { Form } from '@ant-design/compatible';
const { RangePicker } = DatePicker;

import getRecibosPorRangoFecha from '../../../graphql/querys/contravenciones/getRecibosPorRangoFecha.graphql';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsPedido from '../../../actions/pedido';
import * as actionsMain from '../../../actions/main';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import TablaRecibosContravencion from './TablaRecibosContravencion';
import { errorService } from '../../../graphql/utils/utils';

@compose(
  // graphql(getRecibosContravencion, { options: { fetchPolicy: 'network-only' } }),
  graphql(getOrganismos, { name: 'organismos' })
)
class VerRecibosContravencion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: props.usuario.organismo._id,
      currentPage: 1,
      listaTotal: [],
      lista: [],
      fechaInicial: moment().subtract(7, 'd'),
      fechaFinal: moment(),
      pedido: {},
      reporteGeneral: false,
      showTable: false,
      showCheckbox: false,
      rolAutorizado: false,
    };
  }

  componentDidMount() {
    const { usuario } = this.props;
    if (usuario.rol === 'SUPERVISOR' || usuario.rol === 'ADMINISTRADOR') {
      this.setState({
        showCheckbox: true,
        rolAutorizado: true,
      });
    }
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];

    _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState({
      ...this.state,
      listaTotal: lTotal,
    });
  };

  cambiarOrganismo = idOrganismo => {
    // console.log('Voy a cambiar el organismo: ', idOrganismo);
    this.setState({
      ...this.state,
      idOrganismo: idOrganismo,
      filtro: idOrganismo,
    });
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.data.getOrganismos, { _id: idOrganismo });
    organismo ? (nombre = organismo.nombre) : (nombre = '');
    return nombre;
  };

  _executeSearch = async () => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getRecibosPorRangoFecha,
        variables: {
          idOrganismo: this.state.filtro,
          fechaInicio: this.state.fechaInicial,
          fechaFin: this.state.fechaFinal,
        },
        options: { fetchPolicy: 'network-only' },
      })
      .then(res => {
        let lista = res.data.getRecibosPorRangoFecha;
        this.setState({
          loading: false,
          lista: lista,
          showTable: true,
        });
      })
      .catch(err => {
        console.log('ERROR: ', err);
        errorService(err, {
          variables: {
            idOrganismo: this.state.filtro,
            fechaInicio: this.state.fechaInicial,
            fechaFin: this.state.fechaFinal,
          },
        });
      });
  };

  onChangeFechas = date => {
    if (date !== null) {
      this.setState({
        ...this.state,
        fechaInicial: date[0] ? date[0] : '',
        fechaFinal: date[1] ? date[1] : '',
      });
    }
  };

  handleSubmit = () => {
    this._executeSearch();
  };

  onDescargarCSV = () => {
    let data = _.map(this.state.lista, recibo => {
      return {
        organismo: recibo.organismo.nombre,
        fecha: moment(recibo.fechaCreacion).format('DD/MM/YYYY'),
        importe: recibo.contraventor.sancion.monto,
        numero: recibo.numero,
        depositado: recibo.pagado ? 'SI' : 'SIN DEPOSITAR',
        contraventor: recibo.nombre,
      };
    });
    descargarCSV(
      ['ORGANISMO', 'FECHA', 'IMPORTE', 'NUMERO', 'DEPOSITADO', 'CONTRAVENTOR'],
      data,
      `ReporteRecivosContravenciones-${moment(this.state.fechaInicial).format(
        'DD/MM/YYYY'
      )}-${moment(this.state.fechaFinal).format('DD/MM/YYYY')}.csv`
    );
  };

  handleShowTable = value => this.setState({ showTable: value });

  borrarFiltros = () => {
    this.setState({
      ...this.state,
      filtro: '',
      fechaInicial: null,
      fechaFinal: null,
      lista: this.props.data.getRecibosContravencion,
      listaTotal: this.props.data.getRecibosContravencion,
    });
  };

  mostrarModalVerDepositoContravencion = record => {
    this.setState(
      {
        deposito: record,
      },
      () => {
        this.props.actionsMain.setVerDepositoContravencion(
          !this.props.main.verDepositoContravencion
        );
      }
    );
  };

  ocultarModalVerDepositoContravencion = () => {
    // console.log('entre. 2..');
    this.setState(
      {
        deposito: {},
      },
      () => {
        this.props.actionsMain.setVerDepositoContravencion(
          !this.props.main.verDepositoContravencion
        );
      }
    );
  };

  handleCheckboxChange = () => {
    if (this.state.filtro === 'todos') {
      this.setState({
        reporteGeneral: false,
        filtro: this.props.usuario.organismo._id,
      });
    } else {
      this.setState({
        reporteGeneral: true,
        filtro: 'todos',
      });
    }
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    const { usuario } = this.props;

    return (
      <div>
        {!this.state.showTable && (
          <>
            <h2 style={{ textAlign: 'center', marginTop: 120 }}>
              Reporte Recibos Contravencionales
            </h2>

            <Form
              style={{ marginTop: 80 }}
              encType="multipart/form-data"
              onSubmit={this.handleSubmit}
            >
              <Row>
                <Col span={10} style={{ textAlign: 'center', margin: 'auto' }}>
                  <Row>
                    <Col span={5}>
                      <h3>FECHAS: </h3>
                    </Col>
                    <Col span={10}>
                      <RangePicker
                        style={{ width: 350, marginLeft: 10 }}
                        onChange={this.onChangeFechas}
                        defaultValue={[moment().subtract(7, 'd'), moment()]}
                        format={'DD-MM-YYYY'}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row style={{ marginTop: 30 }}>
                <Col span={10} style={{ margin: 'auto' }}>
                  <Row>
                    <Col span={5}>
                      <h3>ORGANISMO: </h3>
                    </Col>
                    <Col span={10}>
                      <Select
                        style={{ width: 350, marginLeft: 10 }}
                        required
                        id="tipoDoc"
                        placeholder="Seleccione un organismo"
                        onSelect={valor => this.cambiarOrganismo(valor)}
                        disabled={
                          this.state.reporteGeneral || !this.state.rolAutorizado
                        }
                        defaultValue={usuario.organismo._id}
                      >
                        {this.props.organismos.getOrganismos &&
                          this.props.organismos.getOrganismos.map(organismo => (
                            <Select.Option
                              key={organismo._id}
                              value={organismo._id}
                            >
                              {organismo.nombre}
                            </Select.Option>
                          ))}
                      </Select>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {this.state.showCheckbox && (
                <Row>
                  <Col style={{ margin: 'auto', marginTop: 20 }}>
                    <Checkbox
                      onChange={this.handleCheckboxChange}
                      checked={this.state.reporteGeneral}
                    >
                      Incluir todos los Organismos
                    </Checkbox>
                  </Col>
                </Row>
              )}
              <Row style={{ marginTop: 30, marginBottom: 100 }}>
                <Col style={{ margin: 'auto' }}>
                  <Button type="primary" htmlType="submit">
                    Generar Reporte
                  </Button>
                </Col>
              </Row>
            </Form>
          </>
        )}
        {this.state.showTable && (
          <div>
            <TablaRecibosContravencion
              recibos={this.state.lista}
              onChange={this.onChangeFechas}
              onDelete={this.onDelete}
              organismos={this.props.organismos.getOrganismos}
              usuario={usuario}
              cambiarOrganismo={this.cambiarOrganismo}
              history={this.props.history}
              verTabla={this.handleShowTable}
              onDescargar={this.onDescargarCSV}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsPedido: bindActionCreators(actionsPedido, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  // console.log('mapStateToPorps: ', state);
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(VerRecibosContravencion));
